import { revertAll } from "@/app/model/actions";
import { UserRolesType } from "@/app/model/types";
import { requestServise } from "@/shared";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ViewerSliceState, ViewerInfoResponse } from "./types";

const initialState: ViewerSliceState = {
  error: null,
  isLoading: false,
  id: "",
  email: "",
  fio: null,
  roleName: null,
  dealerId: null,
  dealerName: null,
  dealerINN: null,
  image: null,
  registrationDate: null,
  blockedDate: null,
  isSkadUser: false,
  isDealerUser: false,
  isTechAdmin: false,
  dealerProlongationDate: null,
};

export const getUser = requestServise.get<{ data: ViewerSliceState }, void>(
  "viewer/getUser",
  "/user/info",
);

export const viewerSlice = createSlice({
  name: "viewer",
  initialState,
  reducers: {
    setViewer(state, action: PayloadAction<ViewerSliceState>) {
      return action.payload;
    },
    removeViever() {
      return initialState;
    },
    changeViewer(state, action: PayloadAction<Partial<ViewerSliceState>>) {
      return (state = { ...state, ...action.payload });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(revertAll, () => initialState);

    builder.addCase(getUser.pending, (state) => {
      state.error = null;
      state.isLoading = true;
    });

    builder.addCase(getUser.fulfilled, (state, action) => {
      const dealerRoles: UserRolesType[] = ["Dealer", "Sales"];
      const skadRoles: UserRolesType[] = ["Admin", "Manager", "TechAdmin"];
      const res = action.payload.data;
      state.id = res.id ?? "";
      state.email = res.email ?? "";
      state.fio = res.fio ?? null;
      state.roleName = res.roleName ?? "Sales";
      state.dealerId = res.dealerId ?? null;
      state.dealerName = res.dealerName ?? null;
      state.dealerINN = res.dealerINN ?? null;
      state.isSkadUser = res.roleName
        ? skadRoles.includes(res.roleName)
        : false;
      state.isDealerUser = res.roleName
        ? dealerRoles.includes(res.roleName)
        : false;
      state.isTechAdmin = res.roleName === "TechAdmin";
      state.registrationDate = res.registrationDate ?? null;
      state.blockedDate = res.blockedDate ?? null;
      state.image = res.image ?? null;
      state.dealerProlongationDate = res.dealerProlongationDate ?? null;
      state.isLoading = false;
    });

    builder.addCase(getUser.rejected, (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    });
  },
});

export const { setViewer, removeViever, changeViewer } = viewerSlice.actions;
